import styled, { StyledProps } from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { sm } from '@ucheba/utils/helpers/styles/mixins'
import { IGridProps } from '@ucheba/ui/components/Grid/types'

const Block = styled.div`
  overflow: hidden;
  position: relative;
  padding-top: ${sm.mathVars(sv.spacing.uxxlarge, '*', 2)};
  padding-bottom: ${sv.spacing.uxxlarge};
`

const FeedbackList = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding-bottom: ${sv.spacing.uxxlarge};
`

const FeedbackListItem = styled.div`
  flex-shrink: 0;
  box-sizing: content-box;
`

const StyledGridCol = styled.div<StyledProps<IGridProps>>`
  display: flex;
  align-items: center;
`

export default { Block, FeedbackList, FeedbackListItem, StyledGridCol }
